export default "__VITE_ASSET__kAt_pyBq__"